export const DOCKER_CONTAINER_URL = 'http://127.0.0.1:5987';
export const DOCKER_INTERNET_IDENTITY_ID = 'rdmx6-jaaaa-aaaaa-aaadq-cai';
